<template>
	<div
		class="relative flex flex-col items-center pb-10 bg-gradient-to-b from-white to-sky-50 md:min-h-[680px] md:-mt-[100px]"
	>
		<h1
			class="relative z-10 mx-7 pt-7 w-[980px] max-w-[76%] sm:max-w-full md:pt-28 text-center text-3xl md:text-7xl leading-normal font-semibold"
		>
			{{ $t(`hero.title.${region}`) }}
		</h1>
		<h3
			class="relative z-10 max-w-xs md:max-w-3xl mx-auto my-4 md:mb-20 text-center text-xl md:text-4xl leading-normal font-normal"
		>
			{{ $t(`hero.subtitle.${isBlue ? "blue" : region}`) }}
		</h3>
		<div
			v-if="isBlue"
			class="hidden md:block z-0 absolute top-0 left-0 bottom-0 right-0 bg-no-repeat bg-[center_bottom] md:bg-[length:170%] lg:bg-auto bg-[url('https://res.cloudinary.com/djbs/image/upload/v1698223058/content/DreamJobs/Graphics/bg_hero-desktop-blue.svg')]"
		></div>
		<div
			v-else
			class="hidden md:block z-0 absolute top-0 left-0 bottom-0 right-0 bg-no-repeat bg-[center_bottom] md:bg-[length:170%] lg:bg-auto bg-[url('https://res.cloudinary.com/djbs/image/upload/v1653298940/content/DreamJobs/Graphics/bg_hero-desktop-2.svg')]"
		></div>
		<SearchbarMain />
		<HeroCategories v-if="isAuth" class="mt-5" />
		<img
			class="md:hidden z-0 absolute left-0 bottom-0"
			src="https://res.cloudinary.com/djbs/image/upload/v1653295820/content/DreamJobs/Graphics/bg_hero-mobile-left.svg"
			role="presentation"
			alt=""
		/>
		<img
			class="md:hidden z-0 absolute right-0 bottom-0"
			src="https://res.cloudinary.com/djbs/image/upload/v1653295820/content/DreamJobs/Graphics/bg_hero-mobile-right.svg"
			role="presentation"
			alt=""
		/>
	</div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
	name: "HeroMain",
	setup() {
		const isAuth = useState("isAuth");

		const { locale } = useI18n();

		const region = ref("HU");

		const isBlue = ref(globalConfig.isBlue);

		onMounted(() => {
			region.value = useRegion.getCurrentRegion().code;
		});

		watchEffect(() => {
			isBlue.value = globalConfig.isBlue;
		});

		return {
			locale,
			region,
			isAuth,
			isBlue,
		};
	},
});
</script>
